import axios from 'axios';
import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import ReactGA from 'react-ga';
import { DateTime } from 'luxon';
import { setDataBox } from '../features/dataBoxHomeSlice';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { setOverlayNotice, setRicarica3612Effettuata, setSwitchGraphMonth, setSwitchGraphYear, setSwitchMonth, setSwitchWeek, setView } from '../features/settingSlice';
import { setCurrentBalance, setInfo, setLoggedIn, setCurrentBalanceEnrica, setCurrentPod, setPodsList, setOfferta, setExpiryBalanceEnrica, setDatiPagamento, setNuoviDatiContratto, setNotifiche, setTotaleConsumi, setTotaleOneri, setUltimoSaldo, setTotaleSaldo, setIdGruppo, setPayMethodDefault, setNomePrenotazione } from '../features/userSlice';
import {ReactComponent as LogoW} from '../assets/img/logo_esteso_wh.svg';

import '../style/Login.scss'
import { setDataMin } from '../features/dataMonthSlice';
import md5 from 'md5';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { setPopupBody } from '../features/popupSlice';

function Login() {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const dispatch = useDispatch();
    const [resetP, setResetP] = useState(false);
    const [codiceFiscale, setCodiceF] = useState()
    const [error, setError] = useState(false)
    const [errorReset, setErrorReset] = useState(false)
    const [trueReset, setTrueReset] = useState(false)


    const TRACKING_ID = "UA-194965307-1"; // YOUR_OWN_TRACKING_ID
    ReactGA.initialize(TRACKING_ID)


    const handleUsername = (e) => {
        e.preventDefault()
        setUsername(e.target.value);
        localStorage.setItem('username', e.target.value);
    };
    const handlePassword = (e) => {
        e.preventDefault()
        setPassword(e.target.value);
        localStorage.setItem('password', e.target.value);
    };
 
    const logIn = async (e) => {
        const loginApi = `https://my.revoluce.it/area_utente/gestione/api/login/login.php?username=${username}&password=${password}`;
        e.preventDefault()
        const { data } = await axios.get(loginApi)
        if(data.success) {
           
            localStorage.setItem('logged', true)
            setError(false)
            dispatch(setOfferta(data.nome_offerta))
            dispatch(setDatiPagamento(data.dati_pagamento))
            dispatch(setPopupBody({body_popup: data.body_popup, titolo_popup: data.titolo_popup, btn_popup: data.btn_popup, link_popup: data.link_popup}))
            dispatch(setOverlayNotice(data.flag_popup))
            dispatch(setRicarica3612Effettuata(data.exist_prenotazione))
            dispatch(setNomePrenotazione(data.nome_prenotazione))
            
            let notifiche = []
            notifiche = [data.notificheRid, data.notificheToken]
            dispatch(setNotifiche(notifiche))
            dispatch(setIdGruppo(data.id_gruppo))
            dispatch(setTotaleConsumi(data.label_consumi))
            dispatch(setTotaleOneri(data.label_altri_oneri))
            dispatch(setUltimoSaldo(data.label_credito_iniziale))
            dispatch(setTotaleSaldo(data.label_totale_saldo))
            const config = data.config_app;
            dispatch(setDataMin(data.data_min));
            dispatch(setView(config.set_view))
            dispatch(setSwitchWeek(config.graph_week))
            dispatch(setSwitchGraphYear(config.set_graph_year))
            dispatch(setSwitchGraphMonth(config.set_graph_month))
            dispatch(setSwitchMonth(config.set_view_month))
            const result = data.data[0];
            dispatch(setInfo(result))
            dispatch(setNuoviDatiContratto(data.nuovi_dati_contratto))
            dispatch(setLoggedIn())
            dispatch(setCurrentBalance(data.saldo))
            dispatch(setCurrentBalanceEnrica(data.saldo_enrica))
            dispatch(setExpiryBalanceEnrica(data.saldo_in_scadenza))
            dispatch(setCurrentPod({podCode: result.pod_code, podName: result.nome, podAddress: result.pod_address2}))
            const podsApi = `https://my.revoluce.it/area_utente/gestione/api/customers_pods/getCustomerPods2.php?codice_fiscale=${result.customer_tax_code}`
            await axios.get(podsApi).then(({ data }) => {
                const podsList = data.data.map((r) => ({podStart: r.pod_start, podStartDate: r.pod_start_date, customerCode: r.customer_code, ownerCity: r.city_name,  ownerAddress: r.pod_address, taxCode: r.customer_tax_code,taxCodeGas: r.customer_tax_code_gas, podOwnerGas: r.customer_full_heading_gas, podOwner: r.customer_full_heading, revoCode: r.codice_revoluzionario, podCode: r.pod_code, podName: r.nome, podAddress: r.pod_address, username: r.user_username, password: r.user_password, customerId: r.customer_id }))
                dispatch(setPodsList(podsList))
                const slicePod = podsList.slice(-1)
                const currentPod = slicePod[0]                 
                // dispatch(setCurrentPod({ podCode: currentPod.podCode, podName: currentPod.podName, podAddress: currentPod.podAddress }))
            })
            const podCode = result.pod_code
            const token = result.token_value
            const userToken = result.user_id
            const dateStart = DateTime.local().startOf("month").toISODate();
            const dateEnd = DateTime.local().endOf("month").toISODate();
            const deliveryMonthNew = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;
            await axios.get(deliveryMonthNew).then(({ data }) => {
                dispatch(setDataBox(data.data.consumptions))
            })
            getMethod(result.customer_id)
            ReactGA.event({
                category: 'Loggato',
                action: result.customer_full_heading,
            });
        } else {
            setError(true)
        }
    }
    const handleCodiceFiscale = (e) => {
        setCodiceF(e)
    }
    const sendRequestReset = async (e) => {
        e.preventDefault()
        if(codiceFiscale){
            const resetApi = `https://my.revoluce.it/area_utente/gestione/api/login/reset_password.php?codice_fiscale=${codiceFiscale}`
            const { data } = await axios.get(resetApi)
            if(data.success){
                setErrorReset(false)
            
                setTrueReset(true)
             
                setTrueReset(true)
                setCodiceF(null)
            } else {
                setErrorReset(true)
            }
        } else {
            setErrorReset(true)
        }
    }
    const getMethod = async (props) => {
        const tkn = md5(props + 'oYmAIdtki%lu')
        const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${props}&tkn_pvt=${tkn}`
        const {data} = await axios.get(apiMethod)
        dispatch(setPayMethodDefault(data.dati.metodo_predefinito))
      }
    return (
        <div className="Login">
            {resetP && (
                <div className="goBack" style={{margin: '30px 30px 0 30px'}}>
                    <ArrowBackIcon style={{color: '#fff'}} onClick={() => setResetP(false)}/>
                </div>
            )}
           
            <div className="container">
                <div className="header">
                <LogoW />
                </div>
                {resetP ? (
                    <>
                        <form onSubmit={sendRequestReset}>
                            <input
                                type="text"
                                placeholder="Codice Fiscale"
                                onChange={(e) => handleCodiceFiscale(e.target.value)}
                            />
                             {
                                trueReset && (
                                    <div className="trueReset">
                                        <p className="main">Password resettata</p>
                                        <p className="secondary">A breve riceverai una mail con le informazioni necessarie per entrare nella tua area.</p>
                                    </div>
                                )
                            }
                            {
                                errorReset && (
                                    <div className="error">
                                        <p className="main">Codice fiascle errato</p>
                                        <p className="secondary">Riprova a scrivere il codice fiscale per recuperare la password.</p>
                                    </div>
                                )
                            }
                             <div className="bottomLogin" onClick={(e) => sendRequestReset(e)}>
                                <button>Reset <ArrowForwardIos fontSize='18px'/></button>
                            </div>
                        </form>
                        
                    </>
                ) : (
                    <>
                        <form onSubmit={logIn}>
                            <input
                                type="text"
                                placeholder="Username"
                                onChange={(e) => handleUsername(e)}
                                value={username}
                            />
                            <input
                                type="password"
                                name="password"
                                autoComplete="on"
                                placeholder="Password"
                                onChange={(e) => handlePassword(e)}
                            />
                             <input type="submit" hidden />
                             {
                                error && (
                                    <div className="error">
                                        <p className="main">Dati di accesso errati</p>
                                        <p className="secondary">Prova ad inserire la tua email come username e il tuo codice fiscale come password.</p>
                                    </div>
                                )
                            }
                            <div className="bottomLogin">
                                <p onClick={() => setResetP(true)}>Hai dimenticato la password?</p>
                                <button onClick={logIn}>Login <ArrowForwardIos fontSize='18px'/></button>
                            </div>
                        </form>
                   
                  
                    </>
                )}
            </div>
        </div>
    )
}

export default Login
